<template>
    <v-card elevation="0">
        <v-card-text>
            <v-row>
                <v-col>
                    <v-btn x-large block color="primary" style="border-radius:8px!important" to="/exchange">
                        <v-layout justify-center align-center style="gap:8px">
                            <v-icon>mdi-wallet-giftcard</v-icon>
                            <span>교환소</span>
                        </v-layout>
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn x-large block color="primary" style="border-radius:8px!important" to="/mypage/cashes/charge">
                        <v-layout justify-center align-center style="gap:8px">
                            <v-icon>mdi-plus-circle-outline</v-icon>
                            <span>캐시충전</span>
                        </v-layout>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {};
</script>

<style></style>
